export function updateAfMenu({ commit }, { path, content, updateMethod = 'concat' }) {
	commit('UPDATE_AF_MENU', { path, content, updateMethod });
}
